import { gql } from '@apollo/client'

export const GET_COURSE_CONTENT = gql`
  query getCourseContent($courseId: ID!, $id: ID!, $enrollmentId: ID!) {
    courseContent(courseId: $courseId, id: $id, enrollmentId: $enrollmentId) {
      lesson {
        description
        media {
          id
          fileUrl
        }
        extraMedias {
          id
          title
          type
          duration
          fileExt
          text
          hostKey
          host
          organizationUuid
          createdAt
        }
      }
    }
  }
`
